export default __webpack_public_path__ + "static/media/Abstracto-orange.c837d9fa.svg";